export interface BankMessageAttachment {
    id: string;
    fileName: string;
    fileSize?: number;
}

export enum BankMessageOrigin {
    MBS = 'MBS',
    CORE = 'CORE',
}

interface BankMessageSource {
    origin: BankMessageOrigin;
    bankServer: {
        id: string;
        name: string;
        description?: string;
    };
}

export enum BankMessageFlag {
    MANDATORY = 'mandatory',
    UNREAD = 'unread',
    UNSIGNED = 'unsigned',
    WARNING = 'warning',
    INFO = 'info',
    DELETABLE = 'deletable',
    ERROR = 'error',
    MBS_MESSAGE = 'mbsMessage',
}

export type BankMessageTypeFlag = BankMessageFlag.INFO | BankMessageFlag.MANDATORY;

export interface BankMessage {
    id: string;
    from: string;
    subject: string;
    date: string;
    body: string;
    attachments?: BankMessageAttachment[];
    flags?: BankMessageFlag[];
    messageSource?: BankMessageSource;
    type?:
        | 'GENERAL'
        | 'MAINTENANCE'
        | 'FEATURE_ANNOUNCEMENT'
        | 'DESIGN_CHANGE'
        | 'FRAUD_WARNING'
        | 'PAYMENT_ISSUE'
        | 'INVESTMENT_INFO';
}

export interface BankMessagesResponse {
    pageNumber: number;
    pageCount: number;
    pageSize: number;
    messages?: BankMessage[];
}
